import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';

import I18nContextProvider from './contexts/i18nContext';
import ToastContextProvider from './contexts/toastContext';
import AuthContextProvider from './contexts/authContext';
import AdminContextProvider from './contexts/adminContext';
import SelectionsContextProvider from './contexts/selectionsContext';
import ProjectsContextProvider from './contexts/projectsContext';
import FeedbackContextProvider from './contexts/feedbackContext';
import NotificationsContextProvider from './contexts/notificationsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nContextProvider>
      <ToastContextProvider>
        <AuthContextProvider>
          <AdminContextProvider>
            <SelectionsContextProvider>
              <ProjectsContextProvider>
                <FeedbackContextProvider>
                  <NotificationsContextProvider>
                    <App />
                  </NotificationsContextProvider>
                </FeedbackContextProvider>
              </ProjectsContextProvider>
            </SelectionsContextProvider>
          </AdminContextProvider>
        </AuthContextProvider>
      </ToastContextProvider>
    </I18nContextProvider>
  </React.StrictMode>
);
